import { useTranslation } from 'react-i18next'
import { useQueryParam } from 'use-query-params'
import { ListInspections } from 'src/features/ListInspections'
import { ListSearchCar } from 'src/features/ListSearchCar'
import { usePermissions } from '~/entities/Viewer'
import { constants } from '~/shared/config'
import { pushFx } from '~/shared/lib/history'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { PageContainer } from '~/shared/ui/PageContainer'

function HomePage() {
  const { t } = useTranslation()
  const { canInspectionCreate } = usePermissions()
  const [searchFilter] = useQueryParam<string>(constants.HEADER_SEARCH_KEY)

  const goToInspection = (carId: UniqueId) => {
    if (!canInspectionCreate) {
      snackbarEnqueued({
        messageI18n: 'alert.no access message',
        variant: 'warning',
      })
      return
    }
    pushFx(`/inspection/${carId}`)
  }

  return (
    <PageContainer
      canSearch
      helmetTitle={t('mechanic')}
      contentTitle={searchFilter ? '' : t('inspected today')}
      canLogout
    >
      {searchFilter ? (
        <ListSearchCar onInspectionStart={goToInspection} />
      ) : (
        <ListInspections />
      )}
    </PageContainer>
  )
}

export default HomePage
